var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],on:{"submit":function($event){$event.preventDefault();return _vm.submit()}}},[_vm._t("default",null,{"errors":_vm.errors}),_vm._v(" "),_vm._t("submit")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }